// Mock data for Waste Loan Bros
export const equipmentTypes = [
  "ROLL-OFF TRUCKS/",
  "FRONT LOADERS/",
  "REAR LOADERS/",
  "COMPACTORS/",
  "BALERS/",
  "RECYCLING/",
  "GRAPPLE TRUCKS/",
  "HOOK LIFTS/",
  "TRANSFER TRUCKS/"
];

export const stats = [
  { value: "$127M+", label: "CAPITAL DEPLOYED" },
  { value: "340+", label: "COMPANIES FUNDED" },
  { value: "98%", label: "REPEAT CLIENTS" },
  { value: "48 HRS", label: "AVG APPROVAL" }
];

export const features = [
  {
    icon: "MessageSquare",
    title: "STRAIGHT TALK",
    description: "No banker jargon. We speak waste."
  },
  {
    icon: "Clock",
    title: "FAST DECISIONS",
    description: "48-hour approvals because time is money."
  },
  {
    icon: "Shield",
    title: "YOUR PARTNER",
    description: "We succeed when you succeed. Period."
  }
];

export const serviceFeatures = [
  {
    icon: "CheckCircle",
    title: "NEW AND USED",
    subtitle: "EQUIPMENT APPROVED"
  },
  {
    icon: "DollarSign",
    title: "LOAN AMOUNTS",
    subtitle: "$10,000 - $500,000+"
  },
  {
    icon: "Calendar",
    title: "FINANCING TERMS",
    subtitle: "24-84 MONTH OPTIONS"
  },
  {
    icon: "Clock",
    title: "FAST RESPONSE",
    subtitle: "APPROVED IN 24 HRS"
  }
];

export const problems = [
  {
    number: "01",
    title: "EQUIPMENT COSTS ARE CRUSHING",
    description: "A single garbage truck can cost $300K+. Banks don't get it."
  },
  {
    number: "02",
    title: "JOBS WAITING, EQUIPMENT ISN'T",
    description: "You've got the contracts. You need the iron to deliver."
  },
  {
    number: "03",
    title: "TRADITIONAL LENDERS MOVE SLOW",
    description: "60-90 day approvals while your competition grows."
  }
];

export const solutions = [
  {
    metric: "48 HRS",
    icon: "Zap",
    title: "FAST APPROVAL",
    description: "48-hour decisions. No waiting weeks while opportunities slip away."
  },
  {
    metric: "$5M+",
    icon: "Truck",
    title: "EQUIPMENT FOCUSED",
    description: "We understand waste. Trucks, compactors, balers—we finance what you need."
  },
  {
    metric: "12-84 MO",
    icon: "Calendar",
    title: "FLEXIBLE TERMS",
    description: "Seasonal cash flow? We structure payments around your reality."
  },
  {
    metric: "25+ YRS",
    icon: "Users",
    title: "INDUSTRY EXPERTS",
    description: "Former waste contractors who speak your language."
  }
];

export const testimonials = [
  {
    quote: "Waste Loan Bros got us a roll-off truck in 6 days. Bank said 3 months. No contest.",
    name: "Mike Hernandez",
    company: "Hernandez Waste Services, TX",
    funded: "$485,000"
  },
  {
    quote: "They understood our seasonal cash flow. Structured payments we could actually make.",
    name: "Sarah Chen",
    company: "Pacific Recycling, CA",
    funded: "$1.2M"
  },
  {
    quote: "Five garbage trucks later, we're still working with WLB. They're family now.",
    name: "Robert Johnson",
    company: "Johnson & Sons Hauling, FL",
    funded: "$2.8M"
  }
];

export const faqs = [
  {
    question: "WHAT EQUIPMENT DO YOU FINANCE?",
    answer: "We finance all types of waste management equipment including roll-off trucks, front loaders, rear loaders, compactors, balers, recycling equipment, grapple trucks, hook lifts, and transfer trucks. Both new and used equipment qualifies."
  },
  {
    question: "HOW FAST CAN I GET FUNDED?",
    answer: "Most applications receive a decision within 48 hours. Once approved, funding can be completed in as little as 5-7 business days depending on the equipment and documentation."
  },
  {
    question: "WHAT ARE YOUR REQUIREMENTS?",
    answer: "We work with businesses that have been operating for at least 2 years with annual revenue of $250K+. We look at the whole picture—not just credit scores. Equipment serves as collateral."
  },
  {
    question: "DO YOU FINANCE NEW AND USED EQUIPMENT?",
    answer: "Yes! We finance both new and used waste management equipment. Used equipment must generally be less than 10 years old, but we evaluate each situation individually."
  },
  {
    question: "WHAT MAKES YOU DIFFERENT FROM BANKS?",
    answer: "We're former waste management contractors ourselves. We understand the industry, the cash flow cycles, and what equipment you actually need. Plus, we move fast—48 hour decisions vs. 60-90 days at traditional banks."
  }
];
